import { useQuery } from "@tanstack/react-query";
export const createVersionQueries = (requests, queryClient) => ({
    useGetApiVersion: (params, options = {}) => useQuery({
        queryKey: ["api-version", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.getApiVersion(params);
        },
        ...options,
    }),
});
//# sourceMappingURL=index.js.map